import { Grid } from "@material-ui/core";
import cloneDeep from "lodash/cloneDeep";
import MaterialTable from "material-table";
import React, { useState } from "react";
import { BoxCard, PageLayout } from "ui/componentes";
import { LocalizationPTBr } from "util/MaterialTableUtil";
import { Collections } from "api/model/Collections";
import { Brand } from "api/model/Brand";
import { useCollection } from "api/hooks/useCollection";
import { BrandForm } from "ui/views/BrandsView/BrandForm";
import { red } from "@material-ui/core/colors";

const BrandsView = () => {
    const [brand, setBrand] = useState<Brand | undefined>();
    const brands = useCollection<Brand[]>(
        {
            collection: Collections.BRANDS,
        },
        true
    );
    brands.sort((brand1, brand2) => (brand1.name < brand2.name ? -1 : 1));

    return (
        <PageLayout
            title="Marcas"
            boxCardProps={{
                display: "flex",
                flexDirection: "column",
            }}
            showInBoxCard={false}
        >
            <Grid container spacing={1}>
                <Grid item xs={6}>
                    <BrandForm
                        brand={brand}
                        onCancel={() => setBrand(undefined)}
                    />
                </Grid>
                <Grid item xs={6} />
                <Grid item xs={12}>
                    <MaterialTable
                        components={{ Container: BoxCard }}
                        columns={[
                            { field: "name", title: "Nome" },
                            {
                                field: "image.downloadURL",
                                title: "Logo",
                                align: "center",
                                filtering: false,
                                render: (brand) => {
                                    if (!brand.image) return "";
                                    return (
                                        <img
                                            src={brand.image.downloadURL}
                                            style={{
                                                maxWidth: "100%",
                                                maxHeight: "60px",
                                            }}
                                            alt="logo-brand"
                                        />
                                    );
                                },
                            },
                        ]}
                        data={cloneDeep(brands)}
                        actions={[
                            {
                                icon: "edit",
                                tooltip: "Editar",
                                onClick: (event, rowData) =>
                                    setBrand(rowData as Brand),
                            },
                        ]}
                        options={{
                            filtering: true,
                            pageSize: 10,
                            toolbar: false,
                            padding: "dense",
                            rowStyle: (rowData) => {
                                if (rowData.id === brand?.id) {
                                    return {
                                        backgroundColor: red["100"],
                                    };
                                }
                                return {};
                            },
                        }}
                        localization={LocalizationPTBr}
                    />
                </Grid>
            </Grid>
        </PageLayout>
    );
};

export { BrandsView };
